import { ActionType } from 'typesafe-actions';

import { StorageNamesEnum } from 'CorePackage/MainModule/enums/StorageNamesEnum';
import { getStorageItem, setStorageItem } from 'CorePackage/MainModule/common/localStore';

import { IPlanListFilterState } from '../interfaces/IPlanListFilterState';
import * as actions from '../actions/planListFilterActions';
import { KnmPlanListFilterActionsEnum } from '../enums/KnmPlanListFilterActionsEnum';
import { IPLanListFilterWithMeta } from '../interfaces/IPLanListFilterWithMeta';

export type PlanListFilterAction = ActionType<typeof actions>;

const initialState: IPlanListFilterState = {
  isLoading: false,
  current: getStorageItem(StorageNamesEnum.PLAN_FILTER),
  isFilterOn: !!getStorageItem(StorageNamesEnum.PLAN_FILTER_ON),
  filters: [],
};

export function planListFilterReducer(state = initialState, action: PlanListFilterAction) {
  switch (action.type) {
    case KnmPlanListFilterActionsEnum.PLAN_LIST_FILTER_SET_CURRENT: {
      const { current, currentId } = action.payload;
      const newState: IPlanListFilterState = {
        ...state,
        current,
        currentId,
      };

      setStorageItem(StorageNamesEnum.PLAN_FILTER, current);

      return newState;
    }
    case KnmPlanListFilterActionsEnum.PLAN_LIST_FILTER_SET_SWITCHER: {
      const { value: isFilterOn } = action.payload;
      const newState: IPlanListFilterState = {
        ...state,
        isFilterOn,
      };

      setStorageItem(StorageNamesEnum.PLAN_FILTER_ON, isFilterOn);

      return newState;
    }
    case KnmPlanListFilterActionsEnum.PLAN_LIST_FILTER_SET_LOADING: {
      const newState: IPlanListFilterState = {
        ...state,
        isLoading: action.payload.value,
      };

      return newState;
    }
    case KnmPlanListFilterActionsEnum.PLAN_LIST_FILTER_SET_META: {
      const filters = action.payload.list.map<IPLanListFilterWithMeta>(meta => ({ meta }));
      const newState: IPlanListFilterState = {
        ...state,
        filters,
      };

      return newState;
    }
    case KnmPlanListFilterActionsEnum.PLAN_LIST_FILTER_REMOVE: {
      const { id } = action.payload;
      const filters = state.filters.filter(f => f.meta.id !== id);
      const newState: IPlanListFilterState = {
        ...state,
        filters,
      };

      return newState;
    }
    case KnmPlanListFilterActionsEnum.PLAN_LIST_FILTER_SET_DATA: {
      const { id, data } = action.payload;
      const filters = state.filters.map<IPLanListFilterWithMeta>(filter => {
        if (filter.meta.id === id) {
          return {
            ...filter,
            data,
          };
        }

        return filter;
      });
      const newState: IPlanListFilterState = {
        ...state,
        filters,
      };

      return newState;
    }
    default:
      return state;
  }
}
